import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../components/AppShell/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

/** The analytics of a link: a card of the panel, its title and period on top. */
export const Panel = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: 0;
  padding: 24px;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  /* the period, smaller than the list's: the title of the panel is small */
  .head .toggle {
    height: 36px;
  }

  .head {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    align-items: center;
    justify-content: space-between;
  }

  h2 {
    font-family: Inter, sans-serif;
    font-size: 0.625rem;
    font-weight: 700;
    line-height: 1rem;
    color: var(--color-neutral-light);
    text-transform: uppercase;
    letter-spacing: 0.03125rem;
  }

  .note {
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    color: var(--color-neutral-150);

    button {
      font-weight: 700;
      color: var(--color-neutral-white);
      text-decoration: underline;
    }
  }

  /* the chart's room, with the Keepo loading in the middle */
  .loading {
    display: grid;
    place-content: center;
    height: 220px;
    background: var(--color-neutral-darkness);
    border-radius: 12px;
  }

  /* a fixed height (the bars stretch to the width), as tall as the lists under it need */
  .chart {
    position: relative;
    width: 100%;
    height: 220px;
  }
`;

/** The clicks of the period, big. */
export const Total = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: baseline;

  strong {
    font-family: Poppins, sans-serif;
    font-size: 2rem;
    font-weight: 700;
    line-height: 2.5rem;
    color: var(--color-neutral-white);
  }

  span {
    font-family: Inter, sans-serif;
    font-size: 0.875rem;
    color: var(--color-neutral-150);
  }
`;

/**
 * The lists (countries, cities, devices, systems, sites) fitted into two columns, each right under the one above it
 * (a long list doesn't leave a gap beside a short one); one column on a phone.
 */
export const Lists = styled.div`
  column-gap: 2rem;
  columns: 2;

  /* room under each block, so the next one's title doesn't sit on the list above it */
  > * {
    margin-bottom: 2.25rem;
    break-inside: avoid;
  }

  @media ${MOBILE} {
    columns: 1;
  }
`;
